module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av148-6c300ccfe241d7f951fcc045e2ca380c.jpg";